<template>
  <div
    class="equipmentWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="topWrap">
      <div class="overview ashComWrap">
        <div class="comTitle">
          <h4>新增用能概览</h4>
        </div>
        <div class="comContentBox">
          <ul class="dataBox">
            <li v-if="overviewList.power && overviewList.power.length">
              <h6>
                {{ overviewList.power[0].name }}/{{
                  overviewList.power[0].unit
                }}
              </h6>
              <h5>{{ overviewList.power[0].value }}</h5>
              <p>
                {{ overviewList.power[1].name }}
                {{ overviewList.power[1].value }}
              </p>
            </li>
            <li v-if="overviewList.loadPower && overviewList.loadPower.length">
              <h6>
                {{ overviewList.loadPower[0].name }}/{{
                  overviewList.loadPower[0].unit
                }}
              </h6>
              <h5>{{ overviewList.loadPower[0].value }}</h5>
              <p>
                {{ overviewList.loadPower[1].name }}
                {{ overviewList.loadPower[1].value }}
              </p>
            </li>
            <li v-if="overviewList.count && overviewList.count.length">
              <h6>
                {{ overviewList.count[0].name }}/{{
                  overviewList.count[0].unit
                }}
              </h6>
              <h5>{{ overviewList.count[0].value }}</h5>
              <p>
                {{ overviewList.count[1].name }}
                {{ overviewList.count[1].value }}
              </p>
            </li>
          </ul>
          <div class="listBox">
            <p class="title">新增碳排放</p>
            <ul v-if="overviewList.discharge && overviewList.discharge.length">
              <li v-for="(v, i) in overviewList.discharge" :key="i">
                <h5>{{ v.value | handleNumPublicFun }}</h5>
                <p>{{ v.name }}/{{ v.unit }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="equipmentEc ashComWrap">
        <div class="comTitle">
          <h4>新增用能设备能耗</h4>
        </div>
        <div class="comContentBox" style="display: flex; align-items: center">
          <div class="ulList">
            <ul>
              <li
                v-for="(v, i) in equipmentEC"
                :key="i"
                :class="{ activeLi: v.key == ecActive }"
                @click="changeECActive(v.key)"
              >
                <p>{{ v.name }}/kw·h</p>
                <h5>{{ v.value.toFixed(1) | handleNumPublicFun }}</h5>
                <div class="txtBox">
                  <p v-if="v.name !== '累计用电'">
                    {{
                      v.name == "今日用电"
                        ? "较昨日"
                        : v.name == "本月用电"
                        ? "较上月"
                        : "较去年"
                    }}
                    {{ v.compare }}
                  </p>
                  <p>占总能耗 {{ v.proportion }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="detailsBox">
            <el-radio-group v-model="radio" size="mini" @change="getECCharts">
              <el-radio-button label="trend">能耗趋势</el-radio-button>
              <el-radio-button label="Proportion">能耗占比</el-radio-button>
            </el-radio-group>
            <div class="lineCharts">
              <PublicEcharts
                id="'id1'"
                :chartsData="chartsData"
                :type="'lightSwitchable'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomWrap">
      <div class="tableWrap ashComWrap">
        <div class="comTitle">
          <div class="tabSelect">
            <el-input
              v-model="equipmentName"
              size="mini"
              placeholder="请输入设备名称"
              style="margin: 0 20px"
            ></el-input>
            <el-button size="mini" @click="getList">查询</el-button>
            <el-button
              type="primary" plain
              v-if="judgeAuthority('nengyuan:addedEnergy:export')"
              size="mini"
              @click="exportExcel"
              ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
            >
          </div>
        </div>
        <div class="comContentBox">
          <div style="width: 95%; height: 90%; margin: 20px auto 10px">
            <el-table
              :data="tableList"
              height="90%"
              stripe
              style="width: 100%"
              size="mini"
              :header-cell-style="{
                'font-weight': 'bold',
                color: '#333',
                'background-color': '#F7F7F7',
              }"
              :cell-style="cellStyle"
              @cell-click="cellClick"
            >
              <el-table-column
                v-for="(v, i) in tableHead"
                :key="i"
                :prop="v.prop"
                :label="v.label"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row[v.prop] && scope.row[v.prop].length >= 8"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row[v.prop]"
                      placement="top-start"
                    >
                      <div>{{ scope.row[v.prop] }}</div>
                    </el-tooltip>
                  </span>
                  <span v-else>{{ scope.row[v.prop] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 30]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              style="text-align: right; margin-top: 10px"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="chartsWrap ashComWrap">
        <div class="comTitle">
          <h4>新增用能设备能耗TOP5</h4>
          <el-radio-group
            v-model="timeSelect"
            size="mini"
            @change="getECTOP"
          >
            <el-radio-button label="DAY">日</el-radio-button>
            <el-radio-button label="MONTH">月</el-radio-button>
            <el-radio-button label="YEAR">年</el-radio-button>
            <el-radio-button label="UNLIMITED">累计</el-radio-button>
          </el-radio-group>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'electricityDay'"
            :chartsData="ecDayChart"
            :type="'horizontalBar'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts.vue";
import api from "@/api";
import { dateFtt, judgeAuthority, exportExcelFun } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  components: {
    PublicEcharts,
  },
  data() {
    return {
      radio: "trend",
      chartsData: {
        type: "line",
        unit: "kw·h",
        showChange: true,
        xData: [],
        dataArr: [],
      },
      ecDayChart: {
        name: "",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      timeSelect: "DAY",
      tableList: [],
      tableHead: [
        { label: "设备名称", prop: "deviceName" },
        { label: "添加时间", prop: "time" },
        { label: "设备类型", prop: "deviceType" },
        { label: "设备ID", prop: "deviceId" },
        { label: "关联系统/资产", prop: "relation" },
        { label: "额定功率/kw", prop: "loadPower" },
        { label: "今日能耗/kw·h", prop: "dayEC" },
        { label: "本月能耗/kw·h", prop: "monthEC" },
        { label: "今年能耗/kw·h", prop: "yearEC" },
        { label: "累计能耗/kw·h", prop: "totalEC" },
      ],
      currentPage: 1,
      page: {
        total: null,
        size: 5,
      },
      equipmentName: "",
      overviewList: {},
      equipmentEC: [],
      ecActive: "",
    };
  },

  methods: {
    judgeAuthority,
    cellStyle(row) {
      if (row.column.label === "设备名称") {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      console.log(row);
      if (column.label == "设备名称") {
        this.$router.push({
          path: "/equipmentmanagement",
          query: { equipmentName: row.deviceName },
        });
      }
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, "新增用能", {
        excel: exportExcelFun(this.tableHead, this.tableList),
      });
    },
    changeECActive(key) {
      this.ecActive = key;
      this.getECCharts();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    async getOverview() {
      let res = await api.energyAddOverview({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.overviewList = res.data.data;
      }
    },
    async getEC() {
      let res = await api.energyAddEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        let data = res.data.data;
        this.equipmentEC = [
          {
            key: "DAY",
            name: "今日用电",
            value: data.day.find((v) => {
              return v.name == "今日用电";
            }).value,
            compare: data.day.find((v) => {
              return v.name == "较昨日";
            }).value,
            proportion: data.day.find((v) => {
              return v.name == "占总能耗";
            }).value,
          },
          {
            key: "MONTH",
            name: "本月用电",
            value: data.month.find((v) => {
              return v.name == "本月用电";
            }).value,
            compare: data.month.find((v) => {
              return v.name == "较上月";
            }).value,
            proportion: data.month.find((v) => {
              return v.name == "占总能耗";
            }).value,
          },
          {
            key: "YEAR",
            name: "本年用电",
            value: data.year.find((v) => {
              return v.name == "本年用电";
            }).value,
            compare: data.year.find((v) => {
              return v.name == "较去年";
            }).value,
            proportion: data.year.find((v) => {
              return v.name == "占总能耗";
            }).value,
          },
          {
            key: "UNLIMITED",
            name: "累计用电",
            value: data.total.find((v) => {
              return v.name == "累计用电";
            }).value,
            proportion: data.total.find((v) => {
              return v.name == "占总能耗";
            }).value,
          },
        ];
        this.ecActive = this.equipmentEC[0].key;
        this.getECCharts();
      }
    },
    async getECCharts() {
      this.chartsData.unit = this.radio == "trend" ? "kw·h" : "%";
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.energyAddECCharts({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.ecActive,
        showType: this.radio,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        let arr = [];
        res.data.data.map((v) => {
          this.chartsData.xData.push(
            this.ecActive == "DAY"
              ? dateFtt("hh时", new Date(v.time))
              : this.ecActive == "YEAR"
              ? dateFtt("MM月", new Date(v.time))
              : this.ecActive == "UNLIMITED"
              ? dateFtt("yyyy年", new Date(v.time))
              : dateFtt("dd日", new Date(v.time))
          );

          arr.push(v.data);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.chartsData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.chartsData.dataArr[i].name = item[i].name;
            this.chartsData.dataArr[i].data.push(item[i].value);
          });
        }
      }
    },
    async getList() {
      let res = await api.energyAddList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceName: this.equipmentName,
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      if (res && res.data.code == 200) {
        this.tableList = res.data.data.data;
        this.page.total = res.data.data.totalElements;
        this.tableList.map((v) => {
          v.time = dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.createdTime));
        });
      }
    },
    async getECTOP() {
      this.ecDayChart.xData = [];
      this.ecDayChart.yData = [];
      let res = await api.energyAddECTop({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeSelect,
      });
      // console.log(res);
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.ecDayChart.xData.push(v.value);
          this.ecDayChart.yData.push(v.name);
        });
      }
    },
  },
  created() {
    this.getOverview();
    this.getEC();
    this.getList();
    this.getECTOP();
  },
};
</script>
<style lang="scss" scoped>
.equipmentWrap {
  @include setPage;
  ::v-deep .cell {
    .el-tooltip {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
  @include setFlexColumn;
  justify-content: space-between;
  align-items: center;
  .topWrap {
    width: 100%;
    height: 37%;
    @include setFlexBetween;
    .overview {
      width: 37%;
      height: 100%;
      .dataBox {
        width: 96%;
        height: 43%;
        margin: 2% auto;
        @include setFlexBetween;
        li {
          width: 32%;
          height: 90%;
          background: #f8fafb;
          border-radius: 8px;
          @include setFlexColumn;
          justify-content: center;
          align-items: center;
          h6 {
            color: #333;
            font-size: 15px;
          }
          h5 {
            color: #28cccb;
            font-size: 32px;
          }
          p {
            color: #666;
          }
        }
      }
      .listBox {
        width: 96%;
        height: 45%;
        background: #f8fafb;
        border-radius: 8px;
        margin: 0 auto;
        .title {
          height: 25%;
          color: #333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }
        ul {
          height: 60%;
          @include setFlexCenter;
          li {
            width: 25%;
            height: 90%;
            position: relative;
            @include setFlexColumn;
            justify-content: center;
            align-items: center;
            h5 {
              color: #28cccb;
              font-size: 30px;
            }
            p {
              color: #666;
            }
          }
          li:nth-child(-n + 2):before {
            content: "";
            height: 30%;
            border-left: 1px solid #e6e6e6;
            position: absolute;
            top: 35%;
            right: 0px;
          }
        }
      }
    }
    .equipmentEc {
      width: calc(63% - 12px);
      height: 100%;
      .ulList {
        width: 42%;
        height: 90%;
        ul {
          width: 96%;
          height: 100%;
          margin: 0 auto;
          @include setFlexBetween;
          flex-wrap: wrap;
          li {
            width: 49%;
            height: 49%;
            border-radius: 8px;
            @include setFlexColumn;
            justify-content: center;
            align-items: center;
            border: 1px solid transparent;
            // border-radius: 7px;
            // border: 1px solid #e4e4e4;
            h5 {
              font-size: 20px;
              margin: 5px 0;
            }
            .txtBox {
              width: 90%;
              @include setFlexCenter;
              p {
                font-size: 12px;
              }
              p:nth-child(2) {
                margin-left: 20px;
              }
            }
          }
          li:hover {
            background: #f8fafb;
          }
          .activeLi {
            background: #f8fafb;
            border: 1px solid #28cccb;
            h5 {
              color: #28cccb;
            }
          }
        }
      }
      .detailsBox {
        width: 58%;
        height: 100%;
        .lineCharts {
          height: 82%;
          width: 100%;
          margin-top: 10px;
        }
      }
    }
  }
  .bottomWrap {
    width: 100%;
    height: calc(63% - 12px);
    @include setFlexBetween;
    .tableWrap {
      width: 69%;
      height: 100%;
      .tabSelect {
        @include setFlexStart;
      }
    }
    .chartsWrap {
      width: calc(31% - 12px);
      height: 100%;
    }
  }
}
</style>